const getDefaultState = () => ({
  profData: null,
  initData: null,
  appointmentData: null,
  formData: null,
  weightUpdateRequired: null,
  historyWeightModified: null,
  appointmentPrice: null,
  immediateVideoAcceptedProfId: null,
  urgentQueue: null,
  queueDisabled: null
})

const appointmentRequestStore = {
    namespaced: true,
    state: {
        profData: null,
        initData: null,
        appointmentData: null,
        formData: null,
        weightUpdateRequired: null,
        historyWeightModified: null,
        appointmentPrice: null,
        immediateVideoAcceptedProfId: null,
        urgentQueue: null,
        queueDisabled: null
    },
    mutations: {
        setFormData (state, data) {
			state.formData = data
		},
        setInitData (state, data) {
            state.initData = {...data, ts: Date.now()}
        },
        setProfData (state, data) {
			state.profData = data
		},
        setAppointmentData (state, data) {
			state.appointmentData = data
		},
        setWeightRequired (state, data) {
            state.weightUpdateRequired = data
        },
        setPatientWeight (state, data) {
            state.appointmentData.patientWeight = data
        },
        setHistoryWeightModified (state, data) {
            state.historyWeightModified = data
        },
        setAppointmentPrice (state, data) {
            state.appointmentPrice = data
        },
        setImmediateVideoAcceptedProfId (state, data) {
            state.immediateVideoAcceptedProfId = data
        },
        setUrgentQueue (state, data) {
            state.urgentQueue = data
        },
        setQueueDisabled (state, data) {
            state.queueDisabled = data
        },
        reset (state) {
            Object.assign(state, getDefaultState())
        }
    },
    getters: {
    }
}

export default appointmentRequestStore


// WEBPACK FOOTER //
// ./src/store/modules/appointmentRequest.js